
import React from 'react';
import { CycleSection } from '../types/cycle';
import { createArcPath, getMiddleAngle } from '../utils/cycleUtils';
import { sections } from '../config/cycleConfig';

interface CycleSectionProps {
  section: CycleSection;
  idx: number;
  center: { x: number; y: number };
}

export const CycleSectionComponent: React.FC<CycleSectionProps> = ({ section, idx, center }) => {
  const startAngle = getMiddleAngle(section.start, section.start);
  const endAngle = getMiddleAngle(section.end + 1, section.end + 1);
  const middleAngle = getMiddleAngle(section.start, section.end);
  
  const textPath = createArcPath(
    center,
    middleAngle - 15,
    middleAngle + 15,
    sections.radii.text
  );

  return (
    <g key={`section-${idx}`}>
      <path
        d={`${createArcPath(center, startAngle, endAngle, sections.radii.outer)} 
            L ${createArcPath(center, endAngle, startAngle, sections.radii.inner).split('M ')[1]} 
            Z`}
        fill={section.color}
        stroke="white"
        strokeWidth="1.5"
      />
      <defs>
        <path id={`textPath-${idx}`} d={textPath} fill="none" />
      </defs>
      <text className="text-[10px] font-bold uppercase">
        <textPath
          href={`#textPath-${idx}`}
          startOffset="50%"
          textAnchor="middle"
          className="fill-gray-700"
        >
          {section.label}
        </textPath>
      </text>
    </g>
  );
};
